export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/logoutIcon.21da734f.svg","height":21,"width":19,"blurWidth":0,"blurHeight":0};